.soundIconWrapper,
.spectatorIconWrapper {
  padding: 0 12px;
}

.soundIconWrapper {
  cursor: pointer;

  &:hover {
    filter: drop-shadow(0px 1px 3px rgba(50, 50, 0, 0.2));
  }
}

.boardAndHand {
  display: flex;
  flex-flow: row nowrap;
  margin: 20px;
}

.whitespaceSpacer {
  flex-grow: 1;
}

.gameBoardWrapper {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  border: 1px solid grey;
  border-radius: 20px;

  /* hiding the octagon/etc shapes for now */
  background: var(--ds-poker-green-lighter);
}

.currentPlayerHand {
}

.currentHandAndTableActions {
  display: flex;
  flex-flow: column nowrap;
  margin-left: 20px;

  & .currentPlayerHand {
    flex-grow: 1;
    display: flex;
    flex-flow: column nowrap;
    /* let flex-grow give this all the height we have */
    height: 1px;
  }
}

.selectedTableCardActions {
  border-radius: 8px;
  margin-top: 20px;
  border: 1px solid var(--ds-pearl-grey-darker);
  padding: 8px 4px;

  &.myTurn .actionChoice {
    cursor: pointer;
    &:hover {
      font-weight: 600;
    }
  }

  &.loading {
    pointer-events: none;
    opacity: 0.6;
  }
}

.gameLogWrapper {
  border: 1px solid var(--ds-pearl-grey-dark);
  border-radius: 4px;
  overflow: scroll;
  padding: 2px 4px;

  /* fixed width because autoscroll stuff gets wacky when this is resizeable
    (onScroll is called when it resizes, before componentDidUpdate -_-)
  */
  width: 250px;
  min-width: 250px;
  margin-left: 40px;
  max-height: 720px;

  & > div:not(:first-child) {
    margin-top: 4px;
  }

  & > div:nth-child(2n) {
    background-color: var(--ds-off-white);
  }

  & > div:hover {
    background-color: var(--ds-off-white-hover);
  }
}

.inactive {
  opacity: 0.6;
}

.hidden {
  display: none;
}
